<template>
  <g>
    <g clip-path="url(#clip0_15_996)">
      <path
        d="M22 3.00018H6.99996C6.30996 3.00018 5.76996 3.35018 5.40996 3.88018L0.369956 11.4502C0.149956 11.7902 0.149956 12.2202 0.369956 12.5602L5.40996 20.1202C5.76996 20.6402 6.30996 21.0002 6.99996 21.0002H22C23.1 21.0002 24 20.1002 24 19.0002V5.00018C24 3.90018 23.1 3.00018 22 3.00018ZM18.3 16.3002C17.91 16.6902 17.28 16.6902 16.89 16.3002L14 13.4102L11.11 16.3002C10.72 16.6902 10.09 16.6902 9.69996 16.3002C9.30996 15.9102 9.30996 15.2802 9.69996 14.8902L12.59 12.0002L9.69996 9.11018C9.30996 8.72018 9.30996 8.09018 9.69996 7.70018C10.09 7.31018 10.72 7.31018 11.11 7.70018L14 10.5902L16.89 7.70018C17.28 7.31018 17.91 7.31018 18.3 7.70018C18.69 8.09018 18.69 8.72018 18.3 9.11018L15.41 12.0002L18.3 14.8902C18.68 15.2702 18.68 15.9102 18.3 16.3002Z"
      />
    </g>
    <defs>
      <clipPath id="clip0_15_996">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.000183105)"
        />
      </clipPath>
    </defs>
  </g>
</template>
